<script>
import { mapState } from "vuex";
// import carousel from "vue-owl-carousel2";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";

export default {
  name: "ViewGeneralCheckersQueueInfoModal",
  data() {
    return {
      modalOpen: false,
      rejectModalOpen: false,
      imageViewerOptions: {
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false
      },
      rejectVodalFormBody: {
        rejectReason: ""
      }
    };
  },
  props: {
    currentData: {
      type: Object,
      required: true
    },
    currentDataJson: {
      type: Object,
      required: true
    }
  },
  // components: { carousel },
  computed: {
    ...mapState(["customer", "branch", "loader"])
  },
  validations: {
    rejectVodalFormBody: {
      rejectReason: { required }
    }
  },
  methods: {
    containz(target, patterns) {
      let value = 0;
      if (patterns) {
        patterns.forEach(function(word) {
          value = value + target.includes(word);
        });
      }
      return value === 1;
    },
    rejectChange() {
      // -close more info modal
      this.closeModal();
      // -open reject modal
      this.openRejectModal();
    },
    rejectChangeFinal() {
      // this.closeRejectModal();
      // -build reject payload
      // -dont forget to add reject reason to th reject payload

      this.$v.$touch();
      if (!this.$v.$invalid) {
        let payload = {
          cqId: this.currentData.cqId,
          cqJson: JSON.stringify(this.currentDataJson),
          cqType: this.currentData.cqType,
          cqMode: "REJECTED",
          cqReason: this.rejectVodalFormBody.rejectReason,
          cqBankCode: StoreUtils.rootGetter("user/getUserBankCode"),
          cqChecker: StoreUtils.rootGetter("user/getUserId")
        };

        StoreUtils.dispatch("branch/setRejectLoading", true);
        StoreUtils.dispatch("queue/authorizeGeneralCheckersQueueItem", {
          payload
        })
          .then(responseData => {
            StoreUtils.dispatch("branch/setRejectLoading", false);
            if (responseData.responseCode === "00") {
              StoreUtils.dispatch("queue/fetchGeneralCheckersQueue");

              this.closeModal();

              this.$emit("authorizeSuccessful");
            }
          })
          .catch(error => {
            throw error;
          });
      }
    },
    authorizeChange() {
      let payload = {
        cqId: this.currentData.cqId,
        cqJson: JSON.stringify(this.currentDataJson),
        cqType: this.currentData.cqType,
        cqMode: "AUTHORIZE",
        cqBankCode: this.$store.getters["user/getUserBankCode"],
        cqChecker: this.$store.getters["user/getUserId"]
      };
      // this.closeModal();

      StoreUtils.dispatch("queue/authorizeGeneralCheckersQueueItem", {
        payload
      })
        .then(responseData => {
          if (responseData.responseCode === "00") {
            StoreUtils.dispatch("queue/fetchGeneralCheckersQueue");
            this.closeModal();
          }
        })
        .catch(error => {
          throw error;
        });
    },
    viewMoreCustomerInfo() {
      this.openModal();
    },
    calculateAge(dob) {
      return Math.trunc(moment().diff(dob, "years", true));
    },
    openModal() {
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
    openRejectModal() {
      this.rejectModalOpen = true;
    },
    closeRejectModal() {
      this.rejectVodalFormBody = {
        rejectReason: ""
      };
      this.$v.$reset();
      this.rejectModalOpen = false;
    }
  }
};
</script>

<template>
  <div>
    <!--        control-->
    <a
      @click="viewMoreCustomerInfo()"
      class="view-customer-info-btn"
      v-b-tooltip.hover.right
      title="View More Info"
    >
      <i class="bx bx-info-circle"></i>
    </a>
    <!--    control END-->

    <!--        actual modal-->
    <vodal
      :show="modalOpen"
      :width="600"
      :height="550"
      measure="px"
      animation="zoom"
      @hide="modalOpen = false"
      :closeOnClickMask="true"
      className="app-modal"
    >
      <div class="card">
        <div class="card-body">
          <!--          <h4 class="card-title mb-4">Customer Info</h4>-->
          <div>
            <div class="view-more-customer-info">
              <div class="view-more-customer-info-wrap">

                <div class="view-more-top">
                  <h4 class="card-title mb-4">Queue Info</h4>
                  <div class="row">
                    <div class="col-sm-6">
                      <p class="queue-title">Users Name</p>
                      <p class="queue-value">
                        {{
                          `${currentData.userFirstName} ${currentData.userMiddleName} ${currentData.userLastName}`
                        }}
                      </p>
                    </div>

                    <div class="col-sm-6">
                      <p class="queue-title">Created At</p>
                      <p class="queue-value">
                        {{ currentData.cqCreatedAt | formatDateRelatively }}
                      </p>
                    </div>

                    <div class="col-sm-6">
                      <p class="queue-title">Users Email</p>
                      <p class="queue-value">{{ currentData.userEmail }}</p>
                    </div>

                    <div class="col-sm-6">
                      <p class="queue-title">Status</p>
                      <p class="queue-value">
                        <AppStatusBadge :status-value="currentData.cqStatus" />
                      </p>
                    </div>
                  </div>
                </div>

                <div class="view-more-base">
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <tbody>
                        <!--                      <p>currentDataJson => {{currentDataJson}}</p>-->
                        <tr v-for="(value, key) in currentDataJson" :key="key">
                          <td>
                            <p class="view-more-base-tag">
                              {{ key }}
                            </p>
                          </td>

                          <td>
                            <div v-if="typeof value === 'string'">
                              <p
                                v-if="value.includes('.png')"
                                class="view-more-base-value"
                              >
                                <span>
                                  <viewer
                                    :title="false"
                                    :options="imageViewerOptions"
                                    :images="[value]"
                                  >
                                    <img
                                      :src="value"
                                      alt=""
                                      class="image-value"
                                    />
                                  </viewer>
                                </span>
                              </p>
                              <p
                                v-else-if="value.includes('.pdf')"
                                class="view-more-base-value isPdf"
                              >
                                <span>
                                  <img
                                    src="https://assets-base.s3.amazonaws.com/img/powerbank/pdf.jpeg"
                                    alt=""
                                    class="image-value"
                                  />
                                </span>
                              </p>
                              <p v-else class="view-more-base-value">
                                {{ value }}
                              </p>
                            </div>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- end table-responsive -->
                </div>

                <p v-if="currentData.cqStatus === 'PENDING'" class="text-right">
                  <span
                    v-if="loader.tableActionButtonLoader"
                    class="formLoaderHold"
                  >
                    <BaseComponentLoader />
                  </span>
                  <span v-else>
                    <span class="reject-btn mr-2">
                      <button
                        @click="rejectChange()"
                        class="btn btn-light mr-1"
                      >
                        <i
                          class="dripicons-cross font-size-16 align-middle mr-2"
                        ></i>
                        Reject
                      </button>
                    </span>
                    <span class="authorize-btn">
                      <button
                        @click="authorizeChange()"
                        class="btn btn-primary mr-1"
                      >
                        <i
                          class="dripicons-checkmark font-size-16 align-middle mr-2"
                        ></i>
                        Authorize
                      </button>
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vodal>

    <vodal
      :show="rejectModalOpen"
      :width="350"
      :height="300"
      measure="px"
      animation="zoom"
      @hide="closeRejectModal"
      :closeOnClickMask="false"
      className="app-modal"
    >
      <div class="card">
        <div class="card-body">
          <!--          <h4 class="card-title mb-4">Customer Info</h4>-->
          <div>
            <div class="view-more-customer-info">
              <div class="view-more-customer-info-wrap">
                <div class="view-more-top">
                  <h4 class="card-title mb-2">Reject Reason</h4>
                  <span class="underground">{{ rejectModalOpen }}</span>
                </div>

                <div class="view-more-base">
                  <form @submit.prevent="rejectChangeFinal">
                    <div class="row">
                      <div class="col-sm-12">
                        <div>
                          <BaseInput
                            :inputType="'text'"
                            v-model="rejectVodalFormBody.rejectReason"
                            placeholder="Reason"
                            :hasPreIcon="false"
                            :label="'Reason'"
                            :class="{
                              error: $v.rejectVodalFormBody.rejectReason.$error
                            }"
                            @blur="$v.rejectVodalFormBody.rejectReason.$touch()"
                          >
                          </BaseInput>

                          <template
                            v-if="$v.rejectVodalFormBody.rejectReason.$error"
                          >
                            <p
                              v-if="
                                !$v.rejectVodalFormBody.rejectReason.required
                              "
                              class="form-error-message"
                            >
                              Reason is required
                            </p>
                          </template>
                        </div>
                      </div>

                      <p class="full-width text-right pr-2">
                        <span
                          v-if="branch.rejectLoading"
                          class="formLoaderHold"
                        >
                          <BaseComponentLoader />
                        </span>
                        <span v-else>
                          <button type="submit" class="btn btn-primary mr-1">
                            Reject
                          </button>
                        </span>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vodal>
  </div>
</template>

<style scoped>
.view-customer-info-btn {
  position: relative;
  height: 20px;
  width: 20px;
  display: block;
  padding: 2px 2px;
  margin-top: 0;
  background-color: #795548;
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
.view-customer-info-btn i {
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
}
p {
  color: #495057;
}
.form-error-message {
  color: #f46a6a;
}
.underground {
  color: transparent;
}
.image-value {
  height: 180px;
  width: 100%;
  cursor: pointer;
  object-fit: cover;
}
</style>
